import { Redirect, useParams } from 'app/routx-router'

export const Component = () => {
  const params = useParams()
  return <Redirect to='waiting' search={params} />
}
export default Component
